import Submissions from './Submissions'

export default Submissions